import React, { ReactNode } from 'react';
import SharedSelection from './SharedSelection';
import { useChatKeyPath } from 'app/models/entityStateSync/keypath';
import { ExtractProps } from 'app/utils/types';
import { StreamPosition } from '@engoo/realtime-protocol/persisted';

interface IProps extends Omit<ExtractProps<typeof SharedSelection>, 'path'> {
  readonly position: StreamPosition;
  readonly children: ReactNode;
}

export default function ChatSharedSelection(
  { position, ...props }: IProps,
) {
  const keyPath = useChatKeyPath({ position });
  return (
    <SharedSelection {...props} path={keyPath} />
  );
}
